//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default{
        name:'bb_form_e_edit',
        data(){
            return{
                get_host:host.host,
                form:{
                    whole_body_skin_status:[],
                    prevention_inoculation_bar:[],
                    baby_nursing_check:[],
                },
                showUserSignature:true,
                showSignature:true,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
            }
        },
        methods:{
            save(){
                let signature ='signature1'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.autograph = encodeURI(png)
                this.showSignature = true
            },
            edit(){
                this.showSignature = false
                 this.form.autograph = ''
            },
            clear(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.autograph = ''
            },
            // 保存客户签名
            saveUserName(){
                let signature ='signature2'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.customer_sign = encodeURI(png)
                this.showUserSignature = true
            },
            //编辑客户签名
            editUserName(){
                this.showUserSignature = false
                 this.form.customer_sign = ''
            },
            //清除客户签名
            clearUserName(){
                let signature ='signature2'
                let refs = this.$refs[signature].clear()
                this.form.customer_sign = ''
            },
            submitForm(){
                this.form.token=this.$cookie.get('token')
                this.form.number_id=this.$cookie.get('id')
                this.form.maternal_info_id=this.$route.query.id
                this.form.id=this.$route.query.form_id
                this.form.store_id=this.$cookie.get('store_id')
                this.form.baby_id=this.$route.query.child_id
                this.form.autograph=this.form.autograph.indexOf(this.get_host) != -1 ? this.form.autograph.replace(this.get_host,'') : this.form.autograph
                this.form.customer_sign=this.form.customer_sign.indexOf(this.get_host) != -1 ? this.form.customer_sign.replace(this.get_host,'') : this.form.customer_sign
                let params = this.form
                let msg = "";
                let keyValue = {"room_number":"房号","assessment_time":"时间"}
                Object.keys(params).forEach(function(key){
                    if(params[key]==""){
                        msg = key+" "+keyValue[key];
                    }
                });
                if(msg!=""){
                    // alert(msg);
                }
                 if(
                    params.room_number==''||params.is_card==''||params.entry_time==''||params.mom_name==''||params.baby_name==''||params.sex==''||params.birth_date==''||params.birth_week==''||
                    params.blood_type==''||params.birth_weight==''||params.birth_length==''||params.apgar_score==''||params.leave_hos_summary==''||params.use_drug_history==''||
                    params.allergy_history==''||params.new_baby_special_case==''||params.leave_hos_jaundice_num==''||params.feed_case==''||params.micturition_case_status==''||
                    params.micturition_num==''||params.habit_diaper_brand==''||params.defecation_case_status==''||params.temperature==''||
                    params.heart_rate_num==''||params.breathing_num==''||params.entry_weight==''||params.spotwo==''||params.face_colour==''||
                    params.cry_sound==''||params.reaction==''||params.limb==''||params.limb_tension_activity==''||
                    params.birth_injury==''||params.nerve_reflex_status==''||params.nutrition_development_status==''||
                    params.whole_body_skin_status.length==0||params.front_fontanelle_status==''||
                    params.mouth_mucosa_status==''||params.eye_blood_secretion==''|| params.sclera_yellow_dye==''||params.nose_shape_status==''||params.breathing_open_status==''||
                    params.ear_shape_status==''||params.abroad_ear_way_shape_status==''||params.umbilicus_abnorma_status==''||params.navelscab_case_staus==''||
                    params.suck_case_status==''||params.hips_status==''||params.vulva_status==''||
                    params.anus_status==''||params.urethra_crack_status==''||params.falsex_menstruation_status==''||params.prevention_inoculation_status==''||
                    params.jaundice_index_num==''||params.other_special_case==''||params.autograph==''||params.assessment_time==''||params.baby_nursing_check.length==0||params.customer_sign==''
                ){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请完善表单',
                    })
                    return
                }
                console.info(params)
                this.$vux.loading.show({
                    text: '正在加载'
                })
                Api.otherFormApi.updateNewBornCheckAssessData(params).then ( res => {
                    this.$vux.loading.hide()
                    console.info(res)
                    if(res.errcode==200){
                        this.$router.replace({
                            path:'/success',
                            query:{
                                id:this.$route.query.id,
                                form_id:this.$route.query.form_id,
                                tabVal: this.$route.query.tabVal,
                                name : 'bb_form_e_edit',
                            }
                        })
                    }
                }) 
            },
            apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.form.mom_name = res.data.name
                        this.form.room_number = res.data.room_name
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            get_baby_list (){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.monthLiveApi.babyList(params).then ( res => {
                    console.info('宝宝信息',res)
                    if(res.errcode == 1){
                        // this.baby_list = res.data
                        // this.form.baby_id = res.data[0].id
                        // this.form.sex = res.data[0].sex == "1" ? "男" : "女"
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            goBack(){
                this.$router.push({
                    path: './maternal_service',
                    query: {
                        id: this.$route.query.id,
                        tabVal: this.$route.query.tabVal
                    }
                })
            }
        },
        created(){
            let params ={
                token:this.$cookie.get('token'),
                id:this.$route.query.form_id
            }
            this.$vux.loading.show({
                text: '正在加载'
            })
            console.info(params)
            Api.otherFormApi.getNewBornCheckAssessFind(params).then (res => {
                this.$vux.loading.hide()
                console.info("详情",res.data)
                if(res.errcode==200){
                   this.form=res.data
                   this.form.whole_body_skin_status=res.data.whole_body_skin_status
                   this.form.baby_nursing_check=res.data.baby_nursing_check
                   this.form.prevention_inoculation_bar=res.data.prevention_inoculation_bar
                   this.form.autograph=res.data.autograph.indexOf(this.get_host) != -1 ? res.data.autograph : this.get_host+res.data.autograph
                    this.form.customer_sign=res.data.customer_sign.indexOf(this.get_host) != -1 ? res.data.customer_sign : this.get_host+res.data.customer_sign
                }
            })
            this.get_baby_list()
        }
    }



// WEBPACK FOOTER //
// ./src/components/bb_form_e_edit.vue